export default {
  path: "/SectionContent/CountyList",
  name: "Counties",
  htmlContent: "county_list.html",
  headings: [],
};
